import { isValidIconElement, Tooltip } from '@farol-ds/react'
import * as RToggleGroup from '@radix-ui/react-toggle-group'
import classNames from 'classnames'
import { cloneElement, forwardRef, ReactNode } from 'react'

import styles from './segmented-control-item.module.scss'

export type SegmentedControlItemElement = HTMLButtonElement

export type SegmentedControlItemProps = RToggleGroup.ToggleGroupItemProps &
  (
    | {
        leftIcon?: ReactNode
        children: ReactNode
        label?: never
      }
    | {
        leftIcon: ReactNode
        children?: never
        label: string
      }
  )

const SegmentedControlItem = forwardRef<SegmentedControlItemElement, SegmentedControlItemProps>(
  function SegmentedControlItem(props, forwardedRef) {
    const { children, className, leftIcon, label, ...rest } = props

    const classes = classNames(styles.root, className)

    const onlyIconMode = !!(leftIcon && !children && label)

    const content = (
      <RToggleGroup.Item
        aria-label={onlyIconMode ? label : undefined}
        {...rest}
        className={classes}
        ref={forwardedRef}
      >
        {isValidIconElement(leftIcon) && cloneElement(leftIcon, { size: 'sm' })}
        {children && <span className={styles.label}>{children}</span>}
      </RToggleGroup.Item>
    )

    if (onlyIconMode) {
      // eslint-disable-next-line @nx/workspace/fds-missing-required-child
      return <Tooltip label={label}>{content}</Tooltip>
    }

    return content
  }
)

export default SegmentedControlItem
